// Detect User Preder Theme 
// const userPrefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
// const userPrefersLight = window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches;
export default {
  mode: 'dark',
  color: {
  },
  // logo:require('logo-path')
}